const twoDigits = (value) => String(value).padStart(2, "0");

const isSameDay = (left, right) =>
  left.getFullYear() === right.getFullYear() &&
  left.getMonth() === right.getMonth() &&
  left.getDate() === right.getDate();

export function formatReceivedAt(value, now = new Date()) {
  if (!value) return "";

  const receivedAt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(receivedAt.getTime())) return "";

  const time = `${twoDigits(receivedAt.getHours())}:${twoDigits(receivedAt.getMinutes())}`;

  if (isSameDay(receivedAt, now)) return `Hoy ${time}`;

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameDay(receivedAt, yesterday)) return `Ayer ${time}`;

  const dayAndMonth = `${twoDigits(receivedAt.getDate())}/${twoDigits(receivedAt.getMonth() + 1)}`;
  if (receivedAt.getFullYear() === now.getFullYear()) return dayAndMonth;

  return `${dayAndMonth}/${String(receivedAt.getFullYear()).slice(-2)}`;
}

export function formatReceivedAtLong(value) {
  if (!value) return "";

  const receivedAt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(receivedAt.getTime())) return "";

  return `${twoDigits(receivedAt.getDate())}/${twoDigits(receivedAt.getMonth() + 1)}/${receivedAt.getFullYear()} ${twoDigits(receivedAt.getHours())}:${twoDigits(receivedAt.getMinutes())}`;
}
